import { Selector } from '@ngrx/store';

import * as RouterStoreSelectors from './router.selector';

export const selectUdid: Selector<object, string> = RouterStoreSelectors.selectRouterParam('udid');

export const selectLocation: Selector<object, string> = RouterStoreSelectors.selectRouterParam('l');
